'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ModalService = function ModalService($http, $q, $rootScope) {
    var INCDOCTYPES = [];
    var LastEpisodeIncDocs = [];
    var MODALSSCONFIG = { INCDOCTYPES: [] };

    /**
     * Get the list of incdoc types
     */
    var getIncDocTypes = function getIncDocTypes() {
        var deferred = $q.defer();
        if (INCDOCTYPES.length === 0) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            $http.get(WEBSERVICEURL + '/dataagility/api/service.toggleselectiontype').then(function successCallback(response) {
                if (INCDOCTYPES.length === 0) {
                    for (var i = 0; i < response.data.length; i++) {
                        if (INCDOCTYPES.indexOf(response.data[i]) === -1) {
                            INCDOCTYPES.push(response.data[i]);
                        }
                    }
                    MODALSSCONFIG.INCDOCTYPES = INCDOCTYPES;
                }
                deferred.resolve(MODALSSCONFIG);
                $rootScope.$emit('incDocTypes-fetched-event', MODALSSCONFIG);
            }, function errorCallback(response) {
                if (response.status === 401) {
                    window.location.replace(window.location.origin + '/login?logout=true');
                }
            });
        } else {
            deferred.resolve(MODALSSCONFIG);
        }
        return deferred.promise;
    };

    /**
     * Get the list of episode toggle selections
     */
    var getEpisodeIncDocs = function getEpisodeIncDocs(episodeAuditId) {
        LastEpisodeIncDocs = [];
        var deferred = $q.defer();
        $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
        $http.get(WEBSERVICEURL + '/dataagility/api/service.episodetoggleselection/' + episodeAuditId + '/getIncDocsForEpisode').then(function successCallback(response) {
            for (var i = 0; i < response.data.length; i++) {
                if (LastEpisodeIncDocs.indexOf(response.data[i]) === -1) {
                    LastEpisodeIncDocs.push(response.data[i]);
                }
            }
            deferred.resolve(LastEpisodeIncDocs);
            $rootScope.$emit('incDocTypes-fetched-event', LastEpisodeIncDocs);
        }, function errorCallback(response) {
            if (response.status === 401) {
                window.location.replace(window.location.origin + '/login?logout=true');
            }
        });
        return deferred.promise;
    };

    /**
     * Update the list of incdoc types
     */
    var updateEpisodeIncDocs = function updateEpisodeIncDocs(episodeAuditId, userId, episodeIncDocs) {
        LastEpisodeIncDocs = [];
        var deferred = $q.defer();
        $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
        $http.post(WEBSERVICEURL + '/dataagility/api/service.episodetoggleselection/' + episodeAuditId + '/user/' + userId + '/updateIncDocsForEpisode', episodeIncDocs).then(function successCallback(response) {
            for (var i = 0; i < response.data.length; i++) {
                if (LastEpisodeIncDocs.indexOf(response.data[i]) === -1) {
                    LastEpisodeIncDocs.push(response.data[i]);
                }
            }
            deferred.resolve(LastEpisodeIncDocs);
            $rootScope.$emit('incDocTypes-fetched-event', LastEpisodeIncDocs);
        }, function errorCallback(response) {
            if (response.status === 401) {
                window.location.replace(window.location.origin + '/login?logout=true');
            }
        });
        return deferred.promise;
    };

    return {
        getEpisodeIncDocs: getEpisodeIncDocs,
        getIncDocTypes: getIncDocTypes,
        MODALSSCONFIG: MODALSSCONFIG,
        updateEpisodeIncDocs: updateEpisodeIncDocs
    };
};

exports.default = ModalService;


// WEBPACK FOOTER //
// ./client/app/common/services/modal.service.js